import { ZonedDateTime } from '@internationalized/date';
import {
  maybeParseZonedDateTime,
  parseZonedDateTime,
} from '@rematter/common/dateTime';
import { RouteStatus } from '@rematter/frontend-lib-api-client';

import { useLoadBoardServicesQuery } from '../queries/useLoadBoardServicesQuery';

import { createMutationHook } from '~/shared/providers/api';

export const useUpdateRouteMutation = createMutationHook(
  'transportation.routeUpdate',
  (params: {
    id: string;
    status?: RouteStatus;
    routeDate?: ZonedDateTime;
    driverId?: string;
    haulerId?: string;
    truckId?: string;
    trailerId?: string;
    facilityGroupId?: string;
    serviceIds?: string[];
  }) => ({
    transportationRouteUpdate: {
      __args: {
        id: params.id,
        input: {
          status: params.status,
          routeDate: params.routeDate?.toAbsoluteString(),
          driverId: params.driverId,
          haulerId: params.haulerId,
          truckId: params.truckId,
          trailerId: params.trailerId,
          facilityGroupId: params.facilityGroupId,
        },
        serviceIds: params.serviceIds,
      },
      id: true,
      description: true,
      status: true,
      documentNumber: true,
      routeDate: true,
      startedAt: true,
      completedAt: true,
      driverId: true,
      haulerId: true,
      truckId: true,
      trailerId: true,
      facilityGroupId: true,
      driver: {
        id: true,
        firstName: true,
        lastName: true,
      },
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
  {
    invalidateQueries: [useLoadBoardServicesQuery],
    select: ({ transportationRouteUpdate: route }) => ({
      id: route.id,
      description: route.description,
      status: route.status,
      documentNumber: route.documentNumber,
      routeDate: maybeParseZonedDateTime(route.routeDate),
      startedAt: maybeParseZonedDateTime(route.startedAt),
      completedAt: maybeParseZonedDateTime(route.completedAt),
      driverId: route.driverId ?? undefined,
      haulerId: route.haulerId ?? undefined,
      truckId: route.truckId ?? undefined,
      trailerId: route.trailerId ?? undefined,
      facilityGroupId: route.facilityGroupId,
      driver: route.driver ?? undefined,
      timestamps: {
        createdAt: parseZonedDateTime(route.timestamps.createdAt),
        updatedAt: parseZonedDateTime(route.timestamps.updatedAt),
      },
    }),
  },
);
